import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=0588fa82"
import script from "./Bank.vue?vue&type=script&lang=js"
export * from "./Bank.vue?vue&type=script&lang=js"
import style0 from "./Bank.vue?vue&type=style&index=0&id=0588fa82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports